import PropTypes from "prop-types";
import { Dialog } from "primereact/dialog";
import { Field } from "react-final-form";
import { useIntl } from "react-intl";
import Form from "../../common/form";
import { TextInput } from "../../common/fields";
import * as Validations from "../../common/form/validator";
import * as SavedReportConstants from "../../../constants/SavedReportConstants";

const SaveReportDialog = ({
  visible,
  title,
  initialName = "",
  requesting = false,
  onHide,
  onSubmit,
}) => {
  const intl = useIntl();
  const nameLabel = intl.formatMessage({ id: "saved_report_name" });

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={title}
      style={{ width: "32rem" }}
      breakpoints={{ "640px": "90vw" }}
    >
      {(visible && (
        <Form
          initialValues={{ name: initialName }}
          requesting={requesting}
          cancelBtn={{
            label: intl.formatMessage({ id: "cancel" }),
            onClick: onHide,
          }}
          submitBtn={{
            label: intl.formatMessage({ id: "save" }),
            onClick: (values) => onSubmit(values.name.trim()),
          }}
        >
          <Field
            name="name"
            component={TextInput}
            label={nameLabel}
            placeholder={nameLabel}
            required
            maxLength={SavedReportConstants.SAVED_REPORT_NAME_MAX_LENGTH}
            validate={Validations.composeValidators(
              Validations.required,
              Validations.maxLength(
                SavedReportConstants.SAVED_REPORT_NAME_MAX_LENGTH
              )
            )}
          />
        </Form>
      )) ||
        null}
    </Dialog>
  );
};

SaveReportDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  initialName: PropTypes.string,
  requesting: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default SaveReportDialog;
